import * as React from 'react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../../atoms/button/button';
import { ErrorList } from '../../molecules/form-elements/error-list/error-list';
import { ContentPanel } from '../../atoms/content-panel/content-panel';
import "./styles.scss";
import { ErrorPanel } from '../../atoms/error-panel/error-panel';

export type IEditableSectionProps = {
  onSubmit: (data: any) => void;
  submitError?: JSX.Element;
  editMode?: boolean;
  sectionTitle: string;
  errors: any;
  onEditModeChange: (mode: boolean) => void;
  editButtonText?: string;
  saveButtonText?: string;
  saveButtonClassName?: string;
  cancelButtonText?: string;
};

const EditableFormSection: React.FunctionComponent<IEditableSectionProps> = (
  { onSubmit, submitError, editMode, sectionTitle, onEditModeChange, children, errors, editButtonText, saveButtonText, saveButtonClassName, cancelButtonText }) => {
  return (
    <ContentPanel panelStyle={editMode ? "white" : "celestial-blue-5"}>
      <div className="cmp-editable-form-section">
        {editMode && (
          <form onSubmit={onSubmit}>
            <div className="row md-spacer-32 spacer-64">
              <div className="col-lg-12 color-malachite-green">
                <h3>{sectionTitle}</h3>
              </div>
            </div>
            {children}
            <div className="row spacer-32">
              <div className="col-lg-12">
                <ErrorList errors={errors}>We found some errors. Please review the form and make the corrections.</ErrorList>
                {submitError && (
                  <ErrorPanel>{submitError}</ErrorPanel>
                )}
              </div>
            </div>
            <div className="row spacer-32">
              <div className="col-lg-12">
                <Button buttonType="button" type="submit" className={saveButtonClassName || "cmp-button--primary"}>{saveButtonText || "Save"}</Button>
                <a href="#" className="cmp-editable-form-section__cancel link--secondary" onClick={() => onEditModeChange(false)} tabIndex={0}>{cancelButtonText || "Cancel"}</a>
              </div>
            </div>
          </form>)}
        {!editMode && (
          <>
            <div className="row md-spacer-32 spacer-64">
              <div className="col-lg-12 color-malachite-green">
                <h3>{sectionTitle}</h3>
              </div>
            </div>
            {children}
            <div className="row spacer-32">
              <div className="col-lg-12">
              </div>
            </div>
            <div className="row spacer-32">
              <div className="col-lg-12">
                <Button buttonType="button" onClick={() => onEditModeChange(true)} className="cmp-button--primary">{editButtonText || "Edit"}</Button>
              </div>
            </div>
          </>
        )}
        <div className="row spacer-16">
        </div>
      </div>
    </ContentPanel>
  );
}

export default EditableFormSection;
